import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { AnalyticsStore, DialogRoute, RouteStore } from 'bernie-core';
import { ClickTracker } from 'bernie-analytics';
import { Layer } from 'bernie-view';

import { mapImages } from 'stores/adapters/bex-api/migration-adapters/property-info/property-info-adapter';

import { SpaceFloorplan } from 'models';

import { ToolbarType } from 'uitk-react-toolbar';
import { UitkLink, UitkLinkAlign } from 'uitk-react-link';
import { UitkMediaGalleryImageDialog, UitkMediaGalleryImageView } from 'uitk-react-media-gallery';

const LinkTracked = ClickTracker(UitkLink);

export interface FloorplanDialogProps {
  id: string;
  layerId: string | number;
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
  floorPlan: SpaceFloorplan;
}

interface FloorplanDialogState {
  showDialog: boolean;
}

@inject('routeStore', 'analytics')
@observer
export class FloorplanDialog extends React.Component<FloorplanDialogProps, FloorplanDialogState> {
  constructor(props) {
    super(props);
    this.onDismiss = this.onDismiss.bind(this);
    this.state = { showDialog: false };
  }

  private onDismiss() {
    this.props.routeStore.goBack();
  }

  public render() {
    const { id, layerId, floorPlan, routeStore, analytics } = this.props;
    const { images, toolbar, trigger } = floorPlan;
    const { showDialog } = this.state;
    const dialogId = `floorplan-dialog-${layerId}`;
    const floorplanImages = images && images.length > 0 ? images.map(mapImages) : null;
    const trackingRfrr = id === 'space-floorplan-dialog' ? 'SpaceDetails.MultiUnit.Floorplan' : 'SpaceDetails.SingleiUnit.Floorplan';
    const query = DialogRoute.appendDialogToQuery(routeStore.search, dialogId);
    const toolbarAnalytics = analytics.setupTracker(trackingRfrr, 'Close floorplan dialog');

    const toolBarAttributes = {
      type: ToolbarType.BACK,
      header: toolbar.title,
    };
    const mediaGalleryControlsAnalytics = analytics.setupTracker(trackingRfrr, 'Change image in floorplan gallery');

    return (
      <div data-stid="spaces-floorplan">
        <LinkTracked className="all-y-padding-two" linkName="Open floor plan dialog" rfrr={trackingRfrr} align={UitkLinkAlign.LEFT}>
          <Link to={{ pathname: routeStore.pathname, search: query }}>{trigger.value}</Link>
        </LinkTracked>
        <DialogRoute id={dialogId} useQueryBuilder={true}>
          <Layer id="floorplan-gallery-dialog" onDismiss={this.onDismiss}>
            <UitkMediaGalleryImageDialog
              className={'spaces-floorplan-gallery'}
              dialogShow={showDialog}
              strictFullscreen={true}
              onDismiss={this.onDismiss}
              analytics={toolbarAnalytics}
              {...toolBarAttributes}
            >
              <UitkMediaGalleryImageView
                images={floorplanImages}
                analytics={mediaGalleryControlsAnalytics}
                galleryName={'Floorplan'}
                currentIndex={0}
              />
            </UitkMediaGalleryImageDialog>
          </Layer>
        </DialogRoute>
      </div>
    );
  }
}
